export default __webpack_public_path__ + "static/media/expl-nn_15_EN.057d808c.png";